import V from 'gcl';
import C from 'vesh';
import Q from 'querystring';

/**
 * 用于通过配置和command直接生成对应的SQL 和 数据集
 * 其中定义
 * 库名/表名/操作
 * create 建表
 * add 增加数据
 * del 删除数据
 * update 修改数据
 * select 查询数据
 * drop 删除表
 * modify 修改表
 * index 索引
 * 库名/操作
 * create 新建库
 * drop 删除库
 * @param {*} crypt 
 */
export const EMBAutoFactoryDecorator = class extends V.NiDataFactory {
    constructor(factory, converter) {
        super();
        const that = this;
        const { _, __ } = pri(that, {
            factory,
            converter,
            AutoConnection: class extends V.NiDataConnection {
                constructor() {
                    super();
                }
                async open() {
                    const conn = __.factory.createDBConnection();
                    if (conn.setParams) conn.setParams(this.params);
                    else
                        V.merge(conn.params, this.params, true);
                    pri(this, { conn });
                    await conn.open();
                    await super.open();
                }
                async close() {
                    const {
                        _,
                        __
                    } = pri(this);
                    if (__.conn && __.conn.isOpen)
                        await __.conn.close();
                    await super.close();
                }
                async invoke(cmd) {
                    if (cmd.params)
                        for (var k in cmd.params) {
                            if (!k.trim().eq(k)) {
                                cmd.params[k.trim()] = cmd.params[k];
                                delete cmd.params[k];
                            }
                        }
                    __.converter.convert(cmd);
                    const conn = pri(this).__.conn;
                    return (conn && conn.isOpen) ? await conn.invoke(cmd) : (function() { throw new Error('数据库未连接!') })();
                }
                async commit() {
                    const conn = pri(this).__.conn;
                    return (conn && conn.isOpen) ? await pri(this).__.conn.commit() : (function() { throw new Error('数据库未连接!') })();
                }
            }
        });
        if(!factory) throw new Error('factory对象为空');
        if(!converter) throw new Error('converter对象为空');
    }
    createDBConnection() {
        const {
            _,
            __
        } = pri(this);
        return new __.AutoConnection();
    }
}


export default {
    EMBAutoFactoryDecorator
};
const pri = V.pris();